module.exports = __webpack_public_path__ + "static/img/1.7e32715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1.jpg
// module id = RG4s
// module chunks = 1